// eslint-disable-next-line
import React, { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import BackDropLoading from 'Utils/Loading';
import LiveBack from "./LiveBack";
import UserBox from "./UserBox";
import { HandleLogin, HandleLogOut } from 'Utils/Helpers/HandleLogin';
import { analyzer, readToken } from "Utils/Helpers/Token";
import { check_server } from "http/components/AuthService";

export default function LoginIndex() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [server, setServer] = useState({status: 1, id: null});
  const { isLogin } = useSelector((state) => ({
      isLogin: state.user.isLogin,
  }));
  useEffect(() => {
    if(checkServer()) {
      if(isLogin) {
        if(analyzer(readToken())) {
          dispatch(HandleLogin(navigate));
        } else {
          dispatch(HandleLogOut());
        }
      }
    }
  }, [dispatch, navigate, isLogin])
  const checkServer = async () => {
    setLoading(true);
    const response = await check_server();
    setLoading(false);
    if(response) {
      setServer({status: 3, id: response})
      return true;
    } else {
      setServer({status: 2, id: null});
      return false;
    }
  }
  return (
    <>
      {
        !isLogin ?
        <div className='app-login flex-row-center-center'>
          <BackDropLoading loading={loading}/>
          <LiveBack />
          <div className={`main-frame flex-column-center-center ${server.status === 2 ? 'no-connection' : ''}`}>
            <UserBox setLoading={(e) => setLoading(e)} server={server.status}/>
          </div>
          { server.id && <server className="d-none">{server.id}</server> }
        </div> : <BackDropLoading loading={true}/>
      }
    </>
  );
}